<template>
  <div>
    <div class="modal modal--welcomeback modal--zero-balance"
         id="subVerifyWifi">
      <div class="modal__content">
        <button class="btn modal-close">
          <i class="icon-close"></i>
        </button>
        <div class="modal__header">
          <h1>{{ getTranslations.home_modals_sub_verify_wifi_error_text }}</h1>
          <img class="usericon"
               src="static/images/sad.svg"
               alt="">
        </div>
        <div class="modal__body"></div>
        <div class="modal__footer"></div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'sub-verify-wifi',
  created() {
    this.showModal();
  },
  methods: {
    showModal() {
      /* eslint-disable */
      const vm = this;
      this.$nextTick(() => {
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(function () {
          vm.$emit('close');
          $('#subVerifyWifi').fadeOut();
        });
      });
      /* eslint-enable */
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/SubscriptionVerifyWifi.vue